/* eslint-disable react/prop-types */
import React from 'react';
import { Table } from 'reactstrap';

export interface TableSkeletonProps {
  columns: number;
  rows?: number;
  enableRowSelection?: boolean;
}

const SkeletonCell: React.FC = () => (
  <td>
    <div className="placeholder-glow">
      <span className="placeholder placeholder-lg w-100" style={{ height: '20px' }}></span>
    </div>
  </td>
);

const SkeletonRow: React.FC<{ columns: number; enableRowSelection?: boolean }> = ({
  columns,
  enableRowSelection,
}) => (
  <tr>
    {enableRowSelection && (
      <td>
        <div className="placeholder-glow">
          <span className="placeholder" style={{ width: '20px', height: '20px' }}></span>
        </div>
      </td>
    )}
    {Array.from({ length: columns }).map((_, i) => (
      <SkeletonCell key={i} />
    ))}
  </tr>
);

export const TableSkeleton = React.memo(
  React.forwardRef<HTMLTableElement, TableSkeletonProps>(
    ({ columns, rows = 5, enableRowSelection = false }, ref) => {
      return (
        <Table
          innerRef={ref} // ← Changed from ref to innerRef
          striped
          bordered
          hover
          className="table-nowrap align-middle"
          style={{ pointerEvents: 'none', opacity: 0.8 }}
        >
          <thead className="table-light">
            <tr>
              {enableRowSelection && (
                <th style={{ width: '50px' }}>
                  <div className="placeholder-glow">
                    <span className="placeholder" style={{ width: '20px', height: '20px' }}></span>
                  </div>
                </th>
              )}
              {Array.from({ length: columns }).map((_, i) => (
                <th key={i}>
                  <div className="placeholder-glow">
                    <span className="placeholder w-100" style={{ height: '20px' }}></span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, i) => (
              <SkeletonRow key={i} columns={columns} enableRowSelection={enableRowSelection} />
            ))}
          </tbody>
        </Table>
      );
    },
  ),
);

TableSkeleton.displayName = 'TableSkeleton';
